import React, { useState } from "react";
import Card from "./Card";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "../styles/CardHover.module.scss";

const CardHover = (props) => {
  const { left, name, url } = props;
  const [isHovering, setIsHovering] = useState(false);

  return (
    <span
      className={styles.text}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <span>
        <Link to={url}>{name}</Link>
      </span>
      {isHovering ? (
        <span className={classNames(styles.hover, { [styles.left]: left })}>
          <Card {...props} background hideName />
        </span>
      ) : null}
    </span>
  );
};

CardHover.propTypes = {
  left: PropTypes.bool,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default CardHover;
